// Requêtes partagées entre plusieurs familles de modules (fiche « à propos », carte des provinces, produits du
// catalogue). Elles vivent dans le paquet commun : un module de fonctionnalité (stocks, logistique, référentiel,
// contrôle) ne doit rien importer de la coquille ni d'un autre module de page, sans quoi les paquets construits
// s'importent mutuellement et l'interface ne se monte pas (voir `vite.config.ts` et `scripts/verifier-paquets.mjs`).

import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import type { APropos, CartePixels } from './types';

export function useAPropos() {
  return useQuery({ queryKey: ['a-propos'], queryFn: async () => (await api<APropos>('/api/v1/a-propos')).donnees, staleTime: 5 * 60_000 });
}

export function useCarte() {
  return useQuery({
    queryKey: ['carte-provinces'],
    queryFn: async () => (await api<CartePixels>('/api/v1/carte/provinces')).donnees,
    staleTime: Infinity,
  });
}

export interface Produit {
  code: string;
  nom: string;
  uniteReference: string;
  estGpl: boolean;
  statut: string;
  densite: { valeur: string; dateEffet: string; motif: string } | null;
}

export function useProduits() {
  return useQuery({ queryKey: ['produits'], queryFn: async () => (await api<Produit[]>('/api/v1/produits')).donnees, staleTime: 5 * 60_000 });
}
